import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

import { useDocumentTitle } from "@/components/page";
import { GOOGLE_LOGIN_URL } from "@/routes/paths";
import { Button } from "@punto-firma/ui/components/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@punto-firma/ui/components/card";

import { CenteredScreen } from "./centered-screen";

const REASONS = [
  "domain_not_allowed",
  "not_member",
  "suspended",
  "no_organizations",
] as const;
type Reason = (typeof REASONS)[number] | "unknown";

const toReason = (value: string | null): Reason =>
  REASONS.find((reason) => reason === value) ?? "unknown";

/**
 * Sin acceso, diciendo por qué. El `api` redirige aquí desde el callback de
 * Google con `?reason=` (`domain_not_allowed`, `not_member`, `suspended`).
 */
export const NoAccessPage = () => {
  const { t } = useTranslation("auth");
  useDocumentTitle(t("noAccess.title"));
  const [searchParams] = useSearchParams();
  const reason = toReason(searchParams.get("reason"));

  return (
    <CenteredScreen>
      <Card>
        <CardHeader>
          <Lock className="size-6 text-muted-foreground" aria-hidden />
          <CardTitle>{t("noAccess.title")}</CardTitle>
          <CardDescription>{t(`noAccess.reasons.${reason}`)}</CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild variant="outline">
            <a href={GOOGLE_LOGIN_URL}>{t("noAccess.otherAccount")}</a>
          </Button>
        </CardContent>
      </Card>
    </CenteredScreen>
  );
};
